import { Component, Input } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';
import { ITimeSupplementReport } from 'src/app/time-tracking/models/time-supplement-report';

@Component({
    selector: 'app-time-supplement-report-grid',
    templateUrl: './time-supplement-report-grid.component.html',
    styleUrl: './time-supplement-report-grid.component.scss',
    standalone: false
})
export class TimeSupplementReportGridComponent {
    constructor(
      private tenantSettingsStore: TenantSettingsStoreService
    ) { }

  @Input() public timeSupplementReports: ITimeSupplementReport[];

    vm$ = combineLatest([
      this.tenantSettingsStore.tenantSettings$
    ]).pipe(
      map(([
        tenantSettings
      ]) => ({
        tenantSettings
      }))
    );
}
